// vim: set ts=2 sw=2 et tw=80 ft=javascript:
/**
 * Copyright (C) 2014, 2015 Minted Inc.
 * All Rights Reserved
 *
 * CTAG:COMMUNITY:IDENTITY
 */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_',
  'minted:community/constants': [],
  'templito:community': []
 })(this, function(m_module, Backbone, $, _) {

  "use strict";

  var M = m_module.M;
  M.View = M.View || {};
  M.Community = M.Community || {};
  M.View.Community = M.View.Community || {};

  /**
   * @class M.View.Community.UserTermsAgreement
   *
   */
  M.View.Community.UserTermsAgreement = Backbone.View.extend({

    template: M.Template.Community.UserTermsAgreement,

    events: {
      'click .reviewLaterButton': 'reviewLaterButtonClick',
      'click .agreeButton:not(.disabled)': 'agreeButtonClick'
    },

    initialize: function() {
      this.$el = $(this.el);
      var that = this;
      this.model.fetch({
        success: function() {
          that.render();
        }
      });
    },

    render: function() {
      if (this.model.get('showDialog')) {
        var html = this.template(this.model.toJSON());
        this.$el.html(html);
        this.$el.dialog({
          width: 600,
          modal: true,
          dialogClass: 'termsAgreement',
          closeOnEscape: false,
          draggable: false,
          resizable: false,
          title: this.options.dialogTitle ? this.options.dialogTitle : 
            M.COMMUNITY.USER_NOTIFICATION_POPUPS.TITLES['termsAndAgreement'],
          open: function() {
            $('.termsAgreement').find('.ui-dialog-titlebar-close').remove();
          }
        });
      }
      return this;
    },

    reviewLaterButtonClick: function() {
      M.GA.trackEvent(
        M.GA.TRACK_EVENT_CATEGORY.COMMUNITY,
        M.GA.TRACK_EVENT_ACTION.USER_TERMS_AGREEMENT_CLICK,
        'review later',
        parseInt(this.model.get('nodeId'), 10)
      );
      this.$el.dialog('close');
    },

    agreeButtonClick: function(e) {
      var that = this;
      $(e.target).addClass('disabled');
      M.GA.trackEvent(
        M.GA.TRACK_EVENT_CATEGORY.COMMUNITY,
        M.GA.TRACK_EVENT_ACTION.USER_TERMS_AGREEMENT_CLICK,
        'agree',
        parseInt(this.model.get('nodeId'), 10)
      );

      $.ajax({
        type: 'POST',
        url: '/user-terms-agreement',
        data: {'nodeTitle': this.model.get('nodeTitle')},
        success: function() {
          that.$el.dialog('close');
        },
        error: function() {
          alert('There has been an error, please try again or ' +
            'refresh the page');
          $(e.target).removeClass('disabled');
        }

      });
    }
  });

  return { };

});
